// extracted by mini-css-extract-plugin
module.exports = {"ArticleImage":"styles_ArticleImage__1CcFN","small":"styles_small__2Awhg","image":"styles_image__3bdl-","big":"styles_big__2Jbuh","grid":"styles_grid__3yYVF"};